import "./ContentArticle.css";
import { useState } from "react";
import Title from "../../common/Title/Title";
import { parseText } from "../../../utils/parseText";
import Lightbox from "../LightBox/LightBox";

export default function ContentArticle({ content }) {
  const [lightboxImage, setLightboxImage] = useState(null);

  const openLightbox = (src, alt) => setLightboxImage({ src, alt });
  const closeLightbox = () => setLightboxImage(null);

  return (
    <div className="content-article-container">
      <div className="content-article">
        {content.map((item, index) => (
          <div key={index} style={item.style} className="content-item" id={item.link || undefined}>
            {item.type === "title" && (
              <div className="content-title">
                <Title text={item.value} size="2rem"/>
              </div>
            )}
            {item.type === "text" && (
              <div className="content-text">{parseText(item.value)}</div>
            )}
            {item.type === "image" && (
              <img
                src={item.value}
                alt={item.alt}
                style={{ margin: 0, marginBottom: item.marginBottom}}
                className="image-clickable"
                onClick={() => openLightbox(item.value, item.alt)}
              />
            )}
            {item.type === "component" && item.value}
          </div>
        ))}
        <Lightbox image={lightboxImage} onClose={closeLightbox} maxZoom={6} />
      </div>
    </div>
  );
}